(function () {
  // Loaded once per section that uses it (e.g. two featured-product sections on the
  // homepage). Bind with a namespace and unbind first, so a second copy of this file
  // doesn't add a second click handler (open + close on the same click).
  const initProductAccordion = () => {
    $(".product-about__accordion-title").off("click.productAbout").on("click.productAbout", function () {
      if (!$(this).hasClass("active")) {
        $(".product-about__accordion-title.active").removeClass("active");
        $(this).addClass("active");
        $(".product-about__accordion-description").stop().slideUp(300);
        $(this)
          .siblings(".product-about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(".product-about__accordion-title").removeClass("active");
        $(".product-about__accordion-description").stop().slideUp(300);
      }
    });
  };

  if (!window.__productAboutListener) {
    window.__productAboutListener = true;
    document.addEventListener("shopify:section:load", function () {
      initProductAccordion();
    });
  }

  initProductAccordion();
})();
